import { render } from "./Embed.vue?vue&type=template&id=5dbc1802&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"

import "./Embed.vue?vue&type=style&index=0&id=5dbc1802&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbc1802"]])

export default __exports__